export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
  }
}

export class AverageResult {
  curriculum_name: string
  curriculum_id: number
  examinee_count: number
  allot: number
  avg_score: number
  std_dev: number
  min_score: number
  max_score: number

  constructor(averageResult: any){
    this.curriculum_name = averageResult.curriculum_name;
    this.curriculum_id = averageResult.curriculum_id;
    this.examinee_count = averageResult.examinee_count;
    this.allot = averageResult.allot;
    this.avg_score = averageResult.avg_score;
    this.std_dev = averageResult.std_dev;
    this.min_score = averageResult.min_score;
    this.max_score = averageResult.max_score;
  }
}

export class BunpuCurriculum {
  curriculum_id: number
  score_from: number
  score_to: number
  bunpu_count: number
  bunpu_per: number

  constructor(bunpuCurriculum: any){
    this.curriculum_id = bunpuCurriculum.curriculum_id;
    this.score_from = bunpuCurriculum.score_from;
    this.score_to = bunpuCurriculum.score_to;
    this.bunpu_count = bunpuCurriculum.bunpu_count;
    this.bunpu_per = bunpuCurriculum.bunpu_per;
  }
}

export class BunpuResult {
  no: number
  curriculum_results: BunpuCurriculum[]
  cols: any[] = new Array<any>()
  colKinds: ColKindEnum[] = new Array<ColKindEnum>()

  constructor(bunpu_result: any){
    this.no = bunpu_result.no;
    this.curriculum_results = bunpu_result.curriculum_results.map((x: any) => new BunpuCurriculum(x));

    this.curriculum_results.forEach(x => {
      this.cols.push(`${x.score_to}点<br>～<br>${x.score_from}点`);
      this.cols.push(`${x.bunpu_count}名`);
      this.cols.push(x.bunpu_per);

      this.colKinds.push(ColKindEnum.ScoreRange);
      this.colKinds.push(ColKindEnum.Count);
      this.colKinds.push(ColKindEnum.ScoreRate);
    })
  }
}

export enum ColKindEnum{
  ScoreRange = 1,
  Count = 2,
  ScoreRate = 3
};